module.exports = __webpack_public_path__ + "static/img/wljcsbsc-CuxqpB18.b510dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/wljcsbsc-CuxqpB18.png
// module id = XUWI
// module chunks = 16